import Dispatcher from './../flux/Dispatcher';
import ActionTypes from '../flux/ActionTypes';

function mapErrorToErrorCode(error) {
  const status = error && error.response && error.response.status;

  switch (status) {
    case 401:
      return ActionTypes.ERROR_HTTP_401;

    case 403:
      window.postMessage(
        JSON.stringify({
          name: 'native-path-change',
          data: { uri: '/login' },
        }),
        '*'
      );
      return ActionTypes.ERROR_HTTP_403;

    case 404:
      return ActionTypes.ERROR_HTTP_404;

    default:
      return ActionTypes.ERROR_HTTP_GENERIC;
  }
}

export default error => Dispatcher.dispatch({
  actionType: mapErrorToErrorCode(error),
  response: error.response,
});
